import { NavLink, Link } from 'react-router-dom';
import { useState } from 'react';
import s from './HeaderNavigation.module.css';
import logo from '../../images/header/logo.png';
import sprite from '../../images/header/sprite.svg';
import menu from '../../JSON/menu.json';
import HeaderMenuList from './HeaderMenuList/HeaderMenuList';

export default function HeaderNavigation() {
  const [query, setQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);

  const [visible, setVisible] = useState(false);
  const [onInput, setOnInput] = useState(false);

  // const onSubmit = event => {
  //   setQuery(query);
  //   setSearchResult([]);
  // };
  // const onChange = event => {
  //   setSearchResult(event.target.value);
  // };

  const toggleMenu = event => {
    event.preventDefault();
    setVisible(visible => !visible);
  };

  // const toggleSearch = event => {
  //   event.preventDefault();
  //   setOnInput(onInput => !onInput);
  // };

  const closeMenu = () => {
    setVisible(false);
  };

  const sendMail = () => {
    const mailto =
      'mailto:mail@gmail.com?subject=Test subject&body=Body content';
    window.location.href = mailto;
  };
  return (
    <nav className={s.navigation}>
      <Link to="/" className={s.logo}>
        <img src={logo} alt={'logo'} />
      </Link>
      <ul className={s.siteNav}>
        <li className={s.item}>
          <div className={s.link} onClick={toggleMenu}>
            Продукти
          </div>
          {visible && <HeaderMenuList menu={menu} onClose={closeMenu} />}
        </li>
        <li className={s.item}>
          <NavLink
            exact
            to="/drivers"
            className={s.link}
            activeClassName={s.activeLink}
          >
            Драйвера та підтримка
          </NavLink>
        </li>
        <li className={s.item}>
          <NavLink to="/about" className={s.link}>
            Про нас
          </NavLink>
        </li>
        <li className={s.item}>
          <NavLink to="/contacts" className={s.link}>
            Контакты
          </NavLink>
        </li>
      </ul>
      <ul className={s.contacts}>
        <li className={s.contactsItems}>
          <Link className={s.contactsLink} to="/searchpage">
            <svg className={s.shape} width="21px" height="21px">
              <use href={sprite + '#icon-Shape'}></use>
            </svg>
          </Link>
        </li>
        <li className={s.contactsItems}>
          <Link to="#" onClick={sendMail} className={s.contactsLink}>
            <svg className={s.mail} width="34px" height="34px">
              <use href={sprite + '#icon-envelop'}></use>
            </svg>
          </Link>
        </li>
      </ul>
    </nav>
  );
}
